export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/transport.12c5003b-999faa.png";